import {ScrollTrigger} from "../LibrariesImport";

export default class BlockPlanComparison {
	static init() {
		document.querySelectorAll(".block-plan-comparison").forEach(block => {
			this.setupStickyHeader(block);
		});
	}

	static setupStickyHeader(block) {
		const thead        = block.querySelector("thead");
		const table        = block.querySelector("table");
		const tableWrapper = block.querySelector(".table-wrapper");
		if (!thead || !table || !tableWrapper) return;

		// Build the sticky bar: section wrapper > block wrapper > table-wrapper > table clone
		// This replicates the full class hierarchy so all SCSS rules and CSS variables apply
		const section      = block.closest(".section, section") || document.body;
		const stickyBar    = document.createElement("div");
		stickyBar.className = "plan-comparison-sticky-bar";

		const sectionInner = document.createElement("div");
		sectionInner.className = section.className; // inherit theme CSS variables

		const blockInner = document.createElement("div");
		blockInner.className = block.className;

		const cloneWrapper = document.createElement("div");
		cloneWrapper.className = "table-wrapper";

		const cloneTable = document.createElement("table");
		cloneTable.className = table.className;

		const cloneThead = thead.cloneNode(true);
		cloneTable.appendChild(cloneThead);
		cloneWrapper.appendChild(cloneTable);
		blockInner.appendChild(cloneWrapper);
		sectionInner.appendChild(blockInner);
		stickyBar.appendChild(sectionInner);
		document.body.appendChild(stickyBar);

		const syncPosition = () => {
			const rect = tableWrapper.getBoundingClientRect();
			stickyBar.style.left  = rect.left + "px";
			stickyBar.style.width = rect.width + "px";

			// Sync each column width from the live thead
			const originalCells = thead.querySelectorAll("tr > *");
			const cloneCells    = cloneThead.querySelectorAll("tr > *");
			originalCells.forEach((cell, i) => {
				if (!cloneCells[i]) return;
				const w = cell.getBoundingClientRect().width + "px";
				cloneCells[i].style.width    = w;
				cloneCells[i].style.minWidth = w;
				cloneCells[i].style.maxWidth = w;
			});

			cloneWrapper.scrollLeft = tableWrapper.scrollLeft;
		};

		ScrollTrigger.create({
			trigger: table,
			start: "top top",
			end: "bottom top",
			onEnter:     () => { syncPosition(); stickyBar.classList.add("is-visible"); },
			onLeaveBack: () => stickyBar.classList.remove("is-visible"),
			onLeave:     () => stickyBar.classList.remove("is-visible"),
		});

		tableWrapper.addEventListener("scroll", () => {
			cloneWrapper.scrollLeft = tableWrapper.scrollLeft;
		});

		window.addEventListener("resize", () => {
			if (stickyBar.classList.contains("is-visible")) syncPosition();
		});
	}
}
